import { useState } from "react";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import "open-iconic/font/css/open-iconic-bootstrap.css";
import {
  Grid,
  TableHeaderRow,
  TableTreeColumn,
  TableColumnResizing,
  Table,
} from "@devexpress/dx-react-grid-bootstrap4";
import {
  CustomTreeData,
  TreeDataState,
  IntegratedSorting,
  SortingState,
} from "@devexpress/dx-react-grid";

const TableComponent = ({ ...restProps }) => (
  <Table.Table {...restProps} className="table-striped" />
);

export default function ResultTable(props) {
  let usersData;

  const getChildRows = (row, rootRows) => {
    const childRows = rootRows.filter(
      (r) => r.parentId === (row ? row.id : null)
    );
    return childRows.length ? childRows : null;
  };

  const [defaultColumnWidths] = useState(props.columnExtensions);

  const statusPriority = {
    InProgress: 1,
    NotStarted: 0,
    Done: 2,
    Completed: 3,
  };

  const comparePriority = (a, b) => {
    if (!a || !a.props) return -1;
    if (!b || !b.props) return 1;

    const priorityA = statusPriority[a.props.status] ?? -1;
    const priorityB = statusPriority[b.props.status] ?? -1;

    if (priorityA === priorityB) return 0;
    return priorityA < priorityB ? -1 : 1;
  };

  const CustomTreeCell = ({ row, children, ...restProps }) => {
    if (row.isGy25FinalExam) {
      const indent = row.level ? row.level * 20 : 0; // 20px per level

      return (
        <TableTreeColumn.Cell
          className="result-row--gy25FinalExam"
          {...restProps}
          indentComponent={() => null}
          contentComponent={() => null}
        >
          <div
            style={{
              marginLeft: `${indent}px`,
              display: "flex",
              alignItems: "center",
            }}
          >
            <span>{row.name}</span>
            <span style={{ marginLeft: "-3em" }}>{children}</span>
          </div>
        </TableTreeColumn.Cell>
      );
    }
    return (
      <TableTreeColumn.Cell {...restProps}>{children}</TableTreeColumn.Cell>
    );
  };

  const comparePercentage = (a, b) => {
    if (!a) return -1;
    if (!b) return 1;

    const getPriority = (value) => {
      if (value === 0) return 0;
      const percentageArray = value.match(/\(\d+%\)/);
      if (!percentageArray) return Number(value);

      const percentage = percentageArray[0].replace(/[()%]/g, "");
      return Number(percentage);
    };

    const priorityA = getPriority(a);
    const priorityB = getPriority(b);

    if (priorityA === priorityB) return 0;
    return priorityA < priorityB ? -1 : 1;
  };

  const [integratedSortingColumnExtensions] = useState([
    { columnName: "status", compare: comparePriority },
    { columnName: "score", compare: comparePercentage },
    { columnName: "activityPoints", compare: comparePercentage },
  ]);
  const [sortingStateColumnExtensions] = useState([
    { columnName: "showResult", sortingEnabled: false },
    { columnName: "lastRun", sortingEnabled: false },
  ]);

  usersData = props.tableData;

  return (
    <Grid rows={usersData} columns={props.columns}>
      <TreeDataState />
      <CustomTreeData getChildRows={getChildRows} />
      <SortingState columnExtensions={sortingStateColumnExtensions} />
      <IntegratedSorting columnExtensions={integratedSortingColumnExtensions} />

      <Table tableComponent={TableComponent} />

      <TableColumnResizing defaultColumnWidths={defaultColumnWidths} />

      <TableHeaderRow showSortingControls />

      <TableTreeColumn for="name" cellComponent={CustomTreeCell} />
    </Grid>
  );
}
